import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { ExportService } from '../../../../shared/services/requests/export.service';
import { IntegrationService } from '../../../../shared/services/requests/integration.service';
import { MatDialog } from '@angular/material/dialog';
import {
  Candidate,
  CleverStaffProfileDupclication,
  SimpleCandidate,
} from '../../../../shared/models';
import { combineLatest, of, Subject, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { CleverStaffExportSettingsAPIPayload } from '../../../../shared/models/export';
import { CleverStaffExportModalComponent } from '../clever-staff-export-modal';

@Component({
  selector: 'app-export-profile-to-cs',
  templateUrl: './export-profile-to-cs.component.html',
  styleUrls: ['./export-profile-to-cs.component.scss'],
  standalone: false,
})
export class ExportProfileToCsComponent implements OnDestroy {
  @Input() profile: Candidate | SimpleCandidate;
  @Input() limitAccess = false;
  @Input() profileHeader = false;
  @Input() disabled = false;

  @Output() modalPendingChange = new EventEmitter<boolean>();

  private unsubscribe$ = new Subject<void>();

  isModalPending = false;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private exportService: ExportService,
    private integrationService: IntegrationService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) {}

  openCleverStaffExportModal(): void {
    this.triggerModalPending(true);

    const { docId } = this.profile as Candidate;
    const $profileDublications = this.integrationService
      .getProfileCleverStaffByDocId(docId)
      .pipe(catchError(() => of(null)));
    const $settings = this.exportService.getCleverStaffSettings();

    combineLatest([$settings, $profileDublications])
      .pipe(
        takeUntil(this.unsubscribe$),
        catchError((error) => {
          this.triggerModalPending(false);
          return throwError(error);
        }),
      )
      .subscribe(
        ([settings, duplications]: [
          CleverStaffExportSettingsAPIPayload,
          CleverStaffProfileDupclication[],
        ]) => {
          const { docId } = this.profile as Candidate;
          this.triggerModalPending(false);

          this.dialog
            .open(CleverStaffExportModalComponent, {
              viewContainerRef: this.viewContainerRef,
              data: { settings: settings, userDocId: docId, duplications },
            })
            .afterClosed()
            .subscribe();

          this.cdr.markForCheck();
        },
      );
  }

  private triggerModalPending(value: boolean): void {
    this.isModalPending = value;

    this.modalPendingChange.emit(value);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
